const creacion = {
  ObtenerDocumento: 'SINOJ/Cedulas/ObtenerDocumento',
  GuardarDatosGeneralesCedula: 'SINOJ/Cedulas/GuardarDatosGeneralesCedula',
  ObtenerCedula: 'SINOJ/Cedulas/ObtenerCedula',
  GuardarDocumento: 'SINOJ/Cedulas/GuardarDocumento',
  GuardarDocumentoResultado: 'SINOJ/Cedulas/GuardarDocumentoResultado',
  GuardarAcuerdosDeCedula: 'SINOJ/Cedulas/GuardarAcuerdosDeCedula',
  GuardarCedula: 'SINOJ/Cedulas/GuardarCedula',
  CancelarCedula: 'SINOJ/Cedulas/CancelarCedula',
  CrearDocumentoDeCedula: 'SINOJ/Cedulas/CrearDocumentoDeCedula',
  CrearDocumentoResultadoDeCedula: 'SINOJ/Cedulas/CrearDocumentoResultadoDeCedula',
  ObtenerDatosUsuario: 'SINOJ/Cedulas/ObtenerDatosDeUsuario',
  GuardarPersonaMoral: 'SINOJ/Cedulas/GuardarPersonaMoral',
  GuardarRelacionDomcilioExpediente: 'SINOJ/Cedulas/GuardarDomicilioAExpediente',
  RemoverDomicilioAExpediente: 'SINOJ/Cedulas/RemoverDomicilioAExpediente'
}

const asignacion = {
  AsignarCedulasANotificador: 'SINOJ/Asignacion/AsignarCedulasANotificador',
  ObtenerCedulasParaAsignacion: 'SINOJ/Asignacion/ObtenerCedulasParaAsignacion',
  RemoverAsignacionDeCedulaANotificador: 'SINOJ/Asignacion/RemoverAsignacionDeCedulaANotificador',
  ObtenerCedulasAsignadas: 'SINOJ/Asignacion/ObtenerCedulasAsignadas',
  RemoverAsignacionDeCedulas: 'SINOJ/Asignacion/RemoverAsignacionDeCedulas',
  ObtenerHistorialDeAsignaciones: 'SINOJ/Asignacion/ObtenerHistorialDeAsignaciones',
  GetReportAsigancionesDeNotificador: 'SINOJ/Asignacion/GetReportAsigancionesDeNotificador'
}

const envio = {
  EnviarCedulasAJuzgado: 'SINOJ/Envio/EnviarCedulasAJuzgado',
  ObtenerCedulasParaEnvioAJuzgado: 'SINOJ/Envio/ObtenerCedulasParaEnvioAJuzgado'
}

const cancelacion = {
  CancelacionDeCedula: 'SINOJ/Cancelacion/CancelacionDeCedula',
  ObtenerCedulaParaCancelacion: 'SINOJ/Cancelacion/ObtenerCedulaParaCancelacion'
}

const correccionSinResultado = {
  ObtenerCedulaParaCorreccion: 'SINOJ/CorreccionSinResultado/ObtenerCedulaParaCorreccion',
  CorreccionACedulaSinResultado: 'SINOJ/CorreccionSinResultado/CorreccionACedula'
}

const correccionConResultado = {
  ObtenerCedulaParaCorreccionCR: 'SINOJ/CorreccionConResultado/ObtenerCedulaParaCorreccionCR',
  CorreccionACedulaConResultado: 'SINOJ/CorreccionConResultado/CorreccionACedulaConResultado'
}

const cedulas = {
  creacion: creacion, 
  asignacion: asignacion,
  envio: envio,
  cancelacion: cancelacion,
  correccionSinResultado: correccionSinResultado,
  correccionConResultado: correccionConResultado 
}

export default cedulas;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/SINOJ/sistema/Cedulas/Cedulas.js
// module id = ke8B
// module chunks = 2